import {microtask} from '@github-ui/eventloop-tasks'
// eslint-disable-next-line no-restricted-imports
import {on} from 'delegated-events'

// Only allow up to a max org members to be featured.
async function limitUsersAndReposSelections({currentTarget}: {currentTarget: Element}) {
  limitFeaturedItemSelections(currentTarget, '.js-sponsors-meet-the-team-search-modal')
}

function isSelectableItemSelected(item: HTMLInputElement | HTMLElement) {
  if (item instanceof HTMLInputElement) return item.checked
  return item.getAttribute('aria-checked') === 'true'
}

// Limit the number of items that can be featured.
async function limitFeaturedItemSelections(root: Element, modalClassSelector: string) {
  const modalContainer = root.querySelector(modalClassSelector)
  if (!modalContainer) return

  await microtask() // https://html.spec.whatwg.org/#resetting-a-form

  const list = modalContainer.querySelector<HTMLUListElement>('.js-sponsors-featured-item-selection-list')
  if (!list) return

  let selectableItems: HTMLElement[] = Array.from(list.querySelectorAll<HTMLInputElement>('input[type=checkbox]'))
  if (selectableItems.length < 1) {
    selectableItems = Array.from(list.querySelectorAll<HTMLElement>('[role=menuitemcheckbox]'))
  }
  const totalSelected = selectableItems.filter(isSelectableItemSelected).length
  const limit = parseInt(list.getAttribute('data-featured-items-limit')!, 10)
  const atSelectionLimit = totalSelected === limit

  for (const el of selectableItems) {
    const disable = atSelectionLimit && !isSelectableItemSelected(el)
    if (el instanceof HTMLInputElement) {
      el.disabled = disable
    } else {
      el.setAttribute('aria-disabled', String(disable))
    }
  }

  const messageEl = modalContainer.querySelector<HTMLSpanElement>('.js-sponsors-featured-items-remaining')
  if (!messageEl) return

  const diff = limit - totalSelected
  messageEl.textContent = `${diff} remaining`
  messageEl.classList.toggle('color-fg-danger', diff < 1)
}

on('change', '.js-sponsors-dashboard-profile-form', limitUsersAndReposSelections)
on('reset', '.js-sponsors-dashboard-profile-form', limitUsersAndReposSelections)

on('click', '.js-sponsors-featured-item-toggle', function (event) {
  const toggleButton = event.currentTarget as HTMLButtonElement
  const form = toggleButton.form
  if (!form) return

  const isDisabled = toggleButton.getAttribute('aria-disabled') === 'true'
  if (isDisabled) return

  const wasChecked = toggleButton.getAttribute('aria-checked') === 'true'
  const newChecked = !wasChecked

  toggleButton.setAttribute('aria-checked', String(newChecked))

  const inputName = toggleButton.getAttribute('data-input-name')!
  const inputValue = toggleButton.getAttribute('data-input-value')!

  if (newChecked) {
    const input = document.createElement('input')
    input.type = 'hidden'
    input.name = inputName
    input.value = inputValue
    form.appendChild(input)
  } else {
    const input = form.querySelector<HTMLInputElement>(`input[name="${inputName}"][value="${inputValue}"]`)
    if (input) input.remove()
  }

  limitUsersAndReposSelections({currentTarget: form})
})
